var render = function render(_c,_vm){return _c('p',{staticClass:"truncate whitespace-nowrap text-xs text-gray-600",attrs:{"title":_vm.props.title}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }